<template lang="html">
  <d-card class="card-small">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="p-0">
      <d-list-group>
        <d-list-group-item v-for="(row, index) in list" :key="index" class="d-flex px-3">
          <span class="text-semibold text-fiord-blue col-10 pl-0">
            <d-input v-model="row.name" class="input-hidden" @change="capitalizeInput(index)"/>
          </span>
          <span class="ml-auto text-right text-semibold col-2 px-0">
            <i class="mr-2 fas fa-plus text-success" @click="addRow()" v-if="index+1 == list.length"></i>
            <i class="fas fa-minus text-danger" @click="removeRow(index)"></i>
          </span>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>

    <d-card-footer class="border-top">
      <d-row>
          <d-col>
          <d-button type="submit" class="btn-primary">Salvar</d-button>
        </d-col>
      </d-row>
    </d-card-footer>

  </d-card>

</template>

<script>
import { mapActions } from 'vuex';
import { capitalize } from '_utils/string';

const MODEL = { id: null, slug: null, name: '' };

export default {
  name: 'quotation-types-form',
  props: {
    list: {
      type: Array,
      default: () => [{ ...MODEL }],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    list() {
      this.checkEmptyOptions(this.list);
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    addRow() {
      return this.list.push({ ...MODEL });
    },
    capitalizeInput(index) {
      this.list[index].name = capitalize(this.list[index].name);
    },
    checkEmptyOptions(list) {
      if (list.length === 0) {
        list.push({ ...MODEL });
      }
    },
    removeRow(index) {
      return this.list.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-hidden {
  width: 100%;
  border: 0;
  padding: 0;
  color: #3D5170;
  font-weight: 400;
  font-size: 15px;
  &:focus {
    box-shadow: none;
    border: 0;
  }
}
</style>
